import React from 'react'
import Model from '../../../common/Model'

const ReportModel = ({
    onClose,
    loading,
    handleSubmit,
    reportData,
    setReportData,
  }) => {
  return (
    <div>
    <Model
      closeModal={onClose}
      title={`Add Report`}
      isForm={true}
      loading={loading}
      handleSubmit={handleSubmit}
    >
      <div>
        <label className="capitalize text-base font-medium mb-3 text-gray-700">
          Your Report
        </label>
        <textarea
          className="w-full p-4 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
          rows="5"
          placeholder="Write your Report here..."
          value={reportData}
          onChange={(e) => setReportData(e.target.value)}
        />
      </div>
    </Model>
  </div>
  )
}

export default ReportModel
